import styles from "./index.module.css";

import React from "react";
import BaseComponent, {executeComponentCallback} from 'Core/components/BaseComponent';
import PropTypes from "prop-types";
import Label from 'Core/components/display/Label';
import Spinner from 'Core/components/display/Spinner';
import {icon_font_error_symbol} from 'Config/app';
import Icon from 'Core/components/display/Icon';
import {Tooltip} from 'Core/components/global/Tooltip';
import {getArray, isset} from 'Core/helpers/data';

class DynamicCampaignRecipients extends BaseComponent {
	constructor(props) {
		super(props, {
			translationPath: 'DynamicCampaignRecipients',
			domPrefix: 'campaign-recipients',
			optimizedUpdate: true,
			optimizedUpdateIgnoreProps: ['onClick', 'onReload'],
		});
	}


	// Render mehods ----------------------------------------------------------------------------------------------------
	render() {
		const {className} = this.props;
		/** @type {?DynamicRecipientsDataObject|undefined} */
		const recipients = this.getProp('recipients');
		const notDefined = (!getArray(recipients, 'conditions').length && !getArray(recipients, 'groups').length);

		return (
			typeof recipients === 'undefined' ?
				<div
					id={this.getDomId()}
					className={`${this.getOption('domPrefix')} ${styles['wrapper']} ${className} card action-card`}
					onClick={e => executeComponentCallback(this.props.onReload, e)}
				>
					<Tooltip
						tag="div"
						title={this.t('failedToLoadError')}
						size="small"
						position="top-center"
						arrow={true}
						interactive={false}
					>
						<div className={`card-content ${styles['content']}`}>
							<Icon symbol={icon_font_error_symbol} className="style-error" />
							<Label
								element="p"
								content={this.t(
									'pings_recipients_section',
									'AppsSection.DefaultApp.projectPages.CampaignPage.ItemPage'
								)}
							/>
						</div>
					</Tooltip>
				</div>
			: recipients === null ?
				<div
					id={this.getDomId()}
					className={`${this.getOption('domPrefix')} ${styles['wrapper']} ${className} card action-card no-action`}
				>
					<div className={`card-content ${styles['content']}`}>
						<Spinner size={50} />
						<Label
							element="p"
							content={this.t(
								'pings_recipients_section',
								'AppsSection.DefaultApp.projectPages.CampaignPage.ItemPage'
							)}
						/>
					</div>
				</div>
			:
				<div
					id={this.getDomId()}
					className={
						`${this.getOption('domPrefix')} ${styles['wrapper']} ${className} card action-card ` +
						(!isset(this.props?.onClick) ? 'no-action' : '')
					}
					onClick={e => executeComponentCallback(this.props.onClick, e)}
				>
					<div className={`card-content ${styles['content']}`}>
						<Icon symbol="users" className={notDefined ? 'style-default' : ''} />
						<Label
							element="p"
							content={this.t(
								'pings_recipients_section',
								'AppsSection.DefaultApp.projectPages.CampaignPage.ItemPage'
							)}
						/>
						<div className={`description ${styles['description']}`}>
							{recipients.conditions.length ? <Label element="div" content={this.t('hasConditions')} /> : null}
							{recipients.groups.length ? <Label element="div" content={this.t('hasGroups')} /> : null}
							{notDefined ? <Label element="div" content={this.t('notSpecified')} /> : null}
						</div>
					</div>
				</div>
		);
	}
}

/**
 * Define the component's own props that can be passed to it by parent components
 */
DynamicCampaignRecipients.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,

	/** @type {DynamicRecipientsDataObject} */
	recipients: PropTypes.object,

	onClick: PropTypes.func,
	onReload: PropTypes.func,
};

/**
 * Define component default values for own props
 */
DynamicCampaignRecipients.defaultProps = {
	id: '',
	className: '',
};

export default DynamicCampaignRecipients;